/**
 * This file will export an object containing the project route path
 */
const paths: { [key: string]: string } = Object.freeze({
  root: '/',
  apartment: '/apartments/:apartmentId',
  requestSent: '/request-sent',
});

export default paths;
